import { ScanLine, Waypoints, Layers, HeartPulse, MoonStar, Wind } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../data/content";

const ICONS = { ScanLine, Waypoints, Layers, HeartPulse, MoonStar, Wind };

export const Services = () => (
  <section id="services" className="relative py-28 sm:py-36 bg-[#F1EDE3]/60 border-y border-[#E3DCCB]/60" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Interventional & Clinical Specializations</Overline>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-800 max-w-3xl leading-snug">
          Every advanced lung procedure, <span className="text-teal-700 italic">under one steady pair of hands.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <article data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+$/, "")}`}
                className="group h-full p-7 rounded-2xl border border-[#E3DCCB] bg-[#FFFFFF]/60 hover:bg-[#F6F2E9]/70 hover:border-teal-500/40 transition-all duration-500 hover:-translate-y-1.5">
                <div className="w-11 h-11 rounded-xl border border-teal-500/30 bg-teal-500/10 flex items-center justify-center text-teal-700 group-hover:scale-110 transition-transform duration-500">
                  <Icon size={20} strokeWidth={1.8} />
                </div>
                <h3 className="mt-6 font-serif-display text-xl font-semibold text-stone-800 leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-stone-500 leading-relaxed">{s.body}</p>
                <p className="mt-5 font-mono-tag text-[10px] uppercase tracking-[0.2em] text-teal-600/70">{s.keywords}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
